import { CommonClientError } from "../../error/client-error";
import { YEAR_MONTH_FORMAT } from "../time-format";
import { YearMonthFunc } from "./year-month";
// @deprecated YearMonthRangeは廃止予定。YearMonthを使用する。
export class YearMonthRange {
    v;
    constructor(v) {
        this.v = v;
    }
    static of({ startOn: startOnValues, endOn: endOnValues, }) {
        const startOn = YearMonthFunc.of(startOnValues);
        const endOn = YearMonthFunc.of(endOnValues);
        return this.between({ startOn, endOn });
    }
    static between({ startOn, endOn }) {
        if (startOn.isAfter(endOn)) {
            throw new CommonClientError.InvalidInput(`startOn[${startOn.toString()}]はendOn[${endOn.toString()}よりも前の月を指定してください。]`, `開始月は終了月よりも前の日付を指定して下さい。`);
        }
        return new YearMonthRange({ startOn, endOn });
    }
    toArray() {
        const array = [];
        for (let yearMonth = this.v.startOn; yearMonth.isEqualOrBefore(this.v.endOn); yearMonth = yearMonth.addMonths(1)) {
            array.push(yearMonth);
        }
        return array;
    }
    toValues() {
        return {
            startOn: this.v.startOn.toValues(),
            endOn: this.v.endOn.toValues(),
        };
    }
    toString() {
        return this.format(YEAR_MONTH_FORMAT);
    }
    format(dateFormat, connectingSign = "~") {
        const startString = this.v.startOn.format(dateFormat);
        const endString = this.v.endOn.format(dateFormat);
        if (startString === endString) {
            return startString;
        }
        return `${startString}${connectingSign}${endString}`;
    }
}
//# sourceMappingURL=year-month-range.js.map